import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as act from './feature-availability.actions';
import { FeatureAvailabilityApiService } from './feature-availability.api.service';

@Injectable()
export class FeatureAvailabilityEffects {
  constructor(
    private actions$: Actions,
    private api: FeatureAvailabilityApiService,
  ) {}

  loadFeatureAvailability$ = createEffect(() =>
    this.actions$.pipe(
      ofType(act.loadFeatureAvailability),
      switchMap(() =>
        this.api.getAvailability().pipe(
          map((features) => act.loadFeatureAvailabilitySuccess({ features })),
          catchError((error) => {
            return of(
              act.loadFeatureAvailabilityFailure({ error: error?.message || 'Error loading feature availability' }),
            );
          }),
        ),
      ),
    ),
  );
}
